export default __webpack_public_path__ + "static/media/zoom-out-icon.3b4c931f.svg";